import * as React from "react";

function SendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M19.972 31.823L30.63 1.37.18 12.03l14.054 5.739 5.74 14.055zm-5.21-16l-8.94-3.65 19.37-6.78-10.43 10.43zM26.61 6.806L19.83 26.18l-3.652-8.942L26.609 6.805z",
    clipRule: "evenodd"
  }));
}

export default SendIcon;